"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatPreview = ChatPreview;
require("antd/lib/badge/style");
var _badge = _interopRequireDefault(require("antd/lib/badge"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
var _EmptyStateIndicator = require("../EmptyStateIndicator");
require("./ChatPreview.less");
var _CustomAvatar = require("../../GroupChats/components/CustomAvatar");
var _utils2 = require("../../GroupChats/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Text = _typography.default.Text,
  Paragraph = _typography.default.Paragraph;
function ChatPreview(props) {
  var _channel$state, _channel$state2, _channel$state2$messa, _channel$lastMessage;
  var owner = props.owner,
    setActiveChannel = props.setActiveChannel,
    channel = props.channel,
    active = props.active,
    _props$closeMenu = props.closeMenu,
    closeMenu = _props$closeMenu === void 0 ? _utils.noop : _props$closeMenu,
    _props$onSelect = props.onSelect,
    onSelect = _props$onSelect === void 0 ? _utils.noop : _props$onSelect,
    client = props.client,
    previewUserId = props.previewUserId,
    clinicianPatients = props.clinicianPatients;
  var members = channel.state.members;
  var member = (0, _utils.getChatMember)({
    owner: owner,
    members: members,
    previewUserId: previewUserId
  });
  var isInChat = (0, _utils.isUserInChat)({
    members: members,
    owner: owner
  });
  var showUnreadCount = !previewUserId && isInChat;
  var userId = client === null || client === void 0 ? void 0 : client.wsConnection.userID;
  var lastReadFromChannel = (0, _utils.getLastRead)({
    channel: channel,
    userId: userId
  });
  var lastRead = (0, _react.useRef)(lastReadFromChannel);
  (0, _react.useEffect)(function () {
    if (active) {
      lastRead.current = new Date();
    }
    return function () {
      lastRead.current = new Date();
    };
  }, [active]);
  var unread = showUnreadCount ? (0, _utils.countUnread)({
    userId: userId,
    lastRead: lastReadFromChannel,
    messages: channel === null || channel === void 0 ? void 0 : (_channel$state = channel.state) === null || _channel$state === void 0 ? void 0 : _channel$state.messages
  }) : 0;
  var _useState = (0, _react.useState)(unread),
    _useState2 = _slicedToArray(_useState, 2),
    unreadCount = _useState2[0],
    setUnreadCount = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!showUnreadCount) {
      return;
    }
    var handleEvent = function handleEvent(e) {
      if (e.channel.id === channel.id) {
        setUnreadCount(0);
        lastRead.current = new Date();
      }
    };
    client.on('notification.mark_read', handleEvent);
    return function () {
      return client.off('notification.mark_read', handleEvent);
    };
  }, [client, channel, previewUserId]);
  (0, _react.useEffect)(function () {
    if (!showUnreadCount) {
      return;
    }
    var handleEvent = function handleEvent() {
      var unread = (0, _utils.countUnread)({
        userId: userId,
        lastRead: lastRead.current,
        messages: channel.state.messages
      });
      setUnreadCount(unread);
      if (active) {
        lastRead.current = new Date();
      }
    };
    channel.on('message.new', handleEvent);
    return function () {
      return channel.off('message.new', handleEvent);
    };
  }, [channel, userId, active, previewUserId]);
  var latestMessage = (0, _utils.getLatestMessage)({
    channel: channel
  });
  var _useState3 = (0, _react.useState)(latestMessage),
    _useState4 = _slicedToArray(_useState3, 2),
    latestMessageText = _useState4[0],
    setLatestMessageText = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!showUnreadCount) {
      return;
    }
    var handleEvent = function handleEvent() {
      var text = (0, _utils.getLatestMessage)({
        channel: channel
      });
      setLatestMessageText(text);
    };
    channel.on('message.updated', handleEvent);
    setLatestMessageText(latestMessage);
    return function () {
      return channel.off('message.updated', handleEvent);
    };
  }, [channel, latestMessage, previewUserId]);
  var noMessages = !(channel !== null && channel !== void 0 && (_channel$state2 = channel.state) !== null && _channel$state2 !== void 0 && (_channel$state2$messa = _channel$state2.messages) !== null && _channel$state2$messa !== void 0 && _channel$state2$messa.length);
  var onSelectChannel = function onSelectChannel() {
    setActiveChannel(channel);
    onSelect();
    /**
     * closeMenu() is used to hide channels list for screens with max-width: 960px,
     * (see details on:
     * https://github.com/GetStream/stream-chat-react/blob/master/src/components/ChannelList.js and
     * https://github.com/GetStream/stream-chat-react/blob/master/src/styles/ChannelList.scss )
     */
    closeMenu();
  };

  // These patients are only available in clinician app, we need it to replace nicknames for real names
  var replaceName = (0, _utils2.getSinglePatientNameByNickName)(member === null || member === void 0 ? void 0 : member.user.name, clinicianPatients);
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "channel-preview".concat(active ? ' active' : ''),
    onClick: onSelectChannel
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-between",
    align: "top",
    gutter: 4
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 18
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "start",
    gutter: 8
  }, member && /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_CustomAvatar.CustomAvatar, {
    image: member.user.image,
    name: replaceName || member.user.name
  })), /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 16
  }, member && /*#__PURE__*/_react.default.createElement(Text, {
    className: "label-small-regular",
    ellipsis: true
  }, replaceName || (0, _utils.composeName)([member === null || member === void 0 ? void 0 : member.user.lastName, member === null || member === void 0 ? void 0 : member.user.firstName]) || (member === null || member === void 0 ? void 0 : member.user.nickName)), /*#__PURE__*/_react.default.createElement(Paragraph, {
    type: "secondary",
    strong: !!unreadCount,
    className: "latest-msg-preview body-small-regular"
  }, noMessages ? /*#__PURE__*/_react.default.createElement(_EmptyStateIndicator.EmptyStateIndicator, {
    type: _EmptyStateIndicator.emptyIndicatorTarget.PREVIEW
  }) : latestMessageText)))), /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 6
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "end"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    className: "caption-regular"
  }, (0, _utils.getChatFormatDate)((_channel$lastMessage = channel.lastMessage()) === null || _channel$lastMessage === void 0 ? void 0 : _channel$lastMessage.created_at))), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "end"
  }, /*#__PURE__*/_react.default.createElement(_badge.default, {
    count: unreadCount
  })))));
}